import { PortObligatoireDesEpis as PortObligatoireDesEpisImage } from '@assets/images';
import balayer from '@assets/images/travaux/balayer.png';
import brancheAppareil from '@assets/images/travaux/branche-appareil.png';
import circuler from '@assets/images/travaux/circuler.png';
import echelle from '@assets/images/travaux/echelle.png';
import electrocution from '@assets/images/travaux/electrocution.png';
import obstaclesSupprimes from '@assets/images/travaux/obstacles-supprimes.png';
import pemp from '@assets/images/travaux/pemp.png';
import pieuvresAttachees from '@assets/images/travaux/pieuvres-attachees.png';
import pirStabilise from '@assets/images/travaux/pir-stabilisée.png';
import protectionsAcierCourbes from '@assets/images/travaux/protections-acier-courbes.png';
import { MinimalStepperProps } from '@components';
import { useHomeSecurity } from '@contexts/HomeSecurityContext/HomeSecurityContext';
import { Textarea, Typography } from '@design-system';
import { ReactNode, useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';

// eslint-disable-next-line react-refresh/only-export-components
const PortObligatoireDesEpis = () => {
    return (
        <div>
            <Typography intrinsic="span">Port obligatoire des EPI</Typography>
            <PortObligatoireDesEpisImage />
        </div>
    );
};

export const useFormationPageVM = () => {
    const [currentStep, setCurrentStep] = useState<number>(0);
    const navigate = useNavigate();
    const { handleAddPassedModule, setWorkStep, worksiteId, otherWorkStep, setOtherWorkStep } = useHomeSecurity();

    const [steps, setSteps] = useState<
        {
            label: string;
            status: 'inProgress' | 'pending' | 'completed';
            isFilled: boolean;
            checkboxes?: { label: string; isChecked: boolean }[];
            content?: { title: string; description: ReactNode }[];
        }[]
    >([
        {
            label: 'Travaux à réaliser',
            status: 'inProgress',
            checkboxes: [
                {
                    label: 'Incorporation des planchers',
                    isChecked: false
                },
                {
                    label: 'Incorporation des banches',
                    isChecked: false
                },
                {
                    label: 'Travaux en sous-sol/garage',
                    isChecked: false
                },
                {
                    label: 'Préparation des descentes de cloisons',
                    isChecked: false
                },
                {
                    label: 'Descentes de cloisons',
                    isChecked: false
                },
                {
                    label: 'Réalisation des colonnes montantes',
                    isChecked: false
                },
                {
                    label: "Pose de l'appareillage",
                    isChecked: false
                },
                {
                    label: 'Pose des convecteurs/sèches-serviettes',
                    isChecked: false
                },
                {
                    label: "Pose d'antennes et/ou paraboles",
                    isChecked: false
                },
                {
                    label: 'Pose de panneaux photovoltaïques',
                    isChecked: false
                },
                {
                    label: 'Alimentation des coffrets électriques provisoires',
                    isChecked: false
                },
                {
                    label: 'Pose de goulotte',
                    isChecked: false
                },
                // {
                //     label: 'Essais',
                //     isChecked: false
                // },
                {
                    label: 'Autre',
                    isChecked: false
                }
            ],
            isFilled: false
        },
        {
            label: 'Incorporation des planchers',
            status: 'pending',
            isFilled: true,
            content: [
                {
                    title: 'Risque',
                    description: "Blessures liées à l'utilisation de l'outillage"
                },
                {
                    title: 'Prévention',
                    description: <PortObligatoireDesEpis />
                },
                {
                    title: 'Risque',
                    description: 'Electrisation / Electrocution'
                },
                {
                    title: 'Prévention',
                    description: (
                        <div>
                            <Typography intrinsic="span">Utilisation de machines conformes aux normes</Typography>
                            <Typography intrinsic="span">
                                Utilisation de prises, prolongateurs, fiches électriques normalisés et en parfait état
                            </Typography>
                            <img src={electrocution} alt="Electrocution" />
                        </div>
                    )
                },
                {
                    title: 'Risque',
                    description: 'Chutes de plain-pied'
                },
                {
                    title: 'Prévention',
                    description: (
                        <div>
                            <Typography intrinsic="span">Maintien les lieux de travail propres et rangés</Typography>
                            <Typography intrinsic="span">Pieuvres en attentes rassemblées et attachées</Typography>
                            <img src={pieuvresAttachees} alt="Pieuvres Attachées" />
                        </div>
                    )
                },
                {
                    title: 'Risque',
                    description: 'Ecrasement de personne par effondrement du matériel de coffrage'
                },
                {
                    title: 'Prévention',
                    description: (
                        <div>
                            <Typography intrinsic="span">
                                N'intervenir que lorsque la stabilité des éléments de coffrage est assurée (Mise en place par entreprise du
                                gros-œuvre…)
                            </Typography>
                        </div>
                    )
                },
                {
                    title: 'Risque',
                    description: 'Empalement sur aciers en attente'
                },
                {
                    title: 'Prévention',
                    description: (
                        <div>
                            <img src={protectionsAcierCourbes} alt="Protections Acier Courbes" />
                            <Typography intrinsic="span">
                                N'intervenir que lorsque les protections des aciers sont mises en œuvre par l'entreprise de gros-œuvre ou
                                que les aciers sont courbés
                            </Typography>
                        </div>
                    )
                },
                {
                    title: 'Risque',
                    description:
                        'Chutes de hauteur (en rive de dalles, de planchers, à travers les trémies, au travers des planchers préfabriqués, des passerelles de travail…)'
                },
                {
                    title: 'Prévention',
                    description: (
                        <div>
                            <Typography intrinsic="span">
                                Intervenir uniquement après mise en place des protections collectives par le gros œuvre. Maintenir en
                                permanence les protections provisoires contre les chutes (trémies, etc.)
                            </Typography>
                        </div>
                    )
                },
                {
                    title: 'Risque',
                    description: "Chutes d'objets"
                },
                {
                    title: 'Prévention',
                    description: (
                        <div>
                            <Typography intrinsic="span">
                                Interdiction de travailler sous grue en mouvement. Interdire le survol des zones électriciens par la grue à
                                tour
                            </Typography>
                            <Typography intrinsic="span">
                                Élinguer les pieuvres avec des élingues textiles en bon état, vérifier l'arrimage, ne pas utiliser d'élingue
                                à usage unique + personnel formé
                            </Typography>
                        </div>
                    )
                },
                {
                    title: 'Risque',
                    description: 'Exposition par inhalation de produit chimique ou/et des poussières de bois, silice'
                },
                {
                    title: 'Prévention',
                    description: (
                        <div>
                            <Typography intrinsic="span">
                                Ne pas intervenir en zone exposée aux poussières. Porter les EPI en cas de risque d'exposition
                            </Typography>
                        </div>
                    )
                }
            ]
        },
        {
            label: 'Incorporation des banches',
            status: 'pending',
            isFilled: true,
            content: [
                {
                    title: 'Risque',
                    description: "Blessures liées à l'utilisation de l'outillage"
                },
                {
                    title: 'Prévention',
                    description: <PortObligatoireDesEpis />
                },
                {
                    title: 'Risque',
                    description: 'Chutes de plain-pied'
                },
                {
                    title: 'Prévention',
                    description: (
                        <div>
                            <Typography intrinsic="span">Fourreaux en attentes rassemblés et attachés</Typography>
                            <Typography intrinsic="span">Stockage des matériaux sans gêner les circulations</Typography>
                        </div>
                    )
                },
                {
                    title: 'Risque',
                    description: 'Chutes de hauteur'
                },
                {
                    title: 'Prévention',
                    description: (
                        <div>
                            <Typography intrinsic="span">Utilisation de plateformes individuelles réglementaires</Typography>
                        </div>
                    )
                },
                {
                    title: 'Risque',
                    description: "Renversement de matériel d'élévation du personnel"
                },
                {
                    title: 'Prévention',
                    description: (
                        <div>
                            <Typography intrinsic="span">
                                CSPS : Nécessité d'un sol stabilisé et dégagé de tout encombrement pour utilisation PIRL
                            </Typography>
                            <img src={echelle} alt="Echelle" />
                        </div>
                    )
                },
                {
                    title: 'Risque',
                    description: 'Ecrasement de personne par renversement du matériel de coffrage'
                },
                {
                    title: 'Prévention',
                    description: (
                        <div>
                            <Typography intrinsic="span">
                                N'intervenir que lorsque la stabilité des éléments de coffrage est assurée (lests, étais tirants poussants,
                                compas, ancrage... mise en place par entreprise du gros-œuvre)
                            </Typography>
                        </div>
                    )
                },
                {
                    title: 'Risque',
                    description: 'Empalement sur aciers en attente'
                },
                {
                    title: 'Prévention',
                    description: (
                        <div>
                            <Typography intrinsic="span">
                                N'intervenir que lorsque les protections des aciers sont mises en œuvre par l'entreprise de gros-œuvre
                                (capuchon, armature crossée, …) ou que les aciers sont courbés
                            </Typography>
                            <img src={protectionsAcierCourbes} alt="Protections Acier Courbes" />
                        </div>
                    )
                },
                {
                    title: 'Risque',
                    description: "Chutes d'objets"
                },
                {
                    title: 'Prévention',
                    description: (
                        <div>
                            <Typography intrinsic="span">
                                Interdiction de travailler sous grue en mouvement. Interdire le survol des zones électriciens par la grue à
                                tour
                            </Typography>
                        </div>
                    )
                },
                {
                    title: 'Risque',
                    description: 'Bruit'
                },
                {
                    title: 'Prévention',
                    description: (
                        <div>
                            <Typography intrinsic="span">Mise à disposition des EPI contre le bruit</Typography>
                        </div>
                    )
                },
                {
                    title: 'Risque',
                    description: "Risques liés à l'utilisation du matériel : Manutention des matériaux"
                },
                {
                    title: 'Prévention',
                    description: (
                        <div>
                            <Typography intrinsic="span">Eviter les travaux superposés</Typography>
                        </div>
                    )
                }
            ]
        },
        {
            label: 'Travaux en sous-sol/garage',
            status: 'pending',
            isFilled: true,
            content: [
                {
                    title: 'Risque',
                    description: "Blessures liées à l'utilisation de l'outillage"
                },
                {
                    title: 'Prévention',
                    description: <PortObligatoireDesEpis />
                },
                {
                    title: 'Risque',
                    description: 'Electrisation / Electrocution'
                },
                {
                    title: 'Prévention',
                    description: (
                        <div>
                            <Typography intrinsic="span">Utilisation de machines conformes aux normes</Typography>
                            <Typography intrinsic="span">
                                Utilisation de prises, prolongateurs, fiches électriques normalisés et en parfait état
                            </Typography>
                        </div>
                    )
                },
                {
                    title: 'Risque',
                    description: 'Exposition par inhalation des poussières (Bois, silice cristalline, produits chimiques)'
                },
                {
                    title: 'Prévention',
                    description: (
                        <div>
                            <Typography intrinsic="span">
                                Ne pas intervenir en zone exposée aux poussières. Porter un masque FFP3 en cas de risque d'inhalation
                            </Typography>
                        </div>
                    )
                },
                {
                    title: 'Risque',
                    description: 'Chutes de plain-pied'
                },
                {
                    title: 'Prévention',
                    description: (
                        <div>
                            <Typography intrinsic="span">Maintenir les lieux de travail propres et rangés</Typography>
                            <Typography intrinsic="span">Stockage des matériaux sans gêner les circulations</Typography>
                            <img src={obstaclesSupprimes} alt="Obstacles Supprimés" />
                        </div>
                    )
                },
                {
                    title: 'Risque',
                    description: 'Chutes de hauteur'
                },
                {
                    title: 'Prévention',
                    description: (
                        <div>
                            <Typography intrinsic="span">
                                Utiliser des équipements réglementaires (PIRL, échafaudage) sur sol stable et dégagé. Assurer des accès
                                libres pour acheminer le matériel. Sous-sol nettoyé, asséché, regards balisés et obturés
                            </Typography>
                            <img src={pirStabilise} alt="PIR Stabilisée" />
                        </div>
                    )
                },
                {
                    title: 'Risque',
                    description: "Chute d'objets (contreplaqué, par trémies, …)"
                },
                {
                    title: 'Prévention',
                    description: (
                        <div>
                            <Typography intrinsic="span">
                                Nécessité de faire décoffrer les plafonds des zones de travail avant l'intervention des électriciens
                            </Typography>
                            <Typography intrinsic="span">
                                Nécessité de faire obturer les trémies supérieures avant intervention des électriciens
                            </Typography>
                        </div>
                    )
                },
                {
                    title: 'Risque',
                    description: 'Bruit'
                },
                {
                    title: 'Prévention',
                    description: (
                        <div>
                            <Typography intrinsic="span">Mise à disposition des EPI contre le bruit</Typography>
                        </div>
                    )
                },
                {
                    title: 'Risque',
                    description: "Risque lié à l'utilisation du matériel et la manutention des matériaux"
                },
                {
                    title: 'Prévention',
                    description: (
                        <div>
                            <Typography intrinsic="span">Planifier les tâches pour éviter la coactivité</Typography>
                        </div>
                    )
                },
                {
                    title: 'Risque',
                    description: 'Chute de plain-pied'
                },
                {
                    title: 'Prévention',
                    description: (
                        <div>
                            <Typography intrinsic="span">
                                Stockage des matériaux sans gêner les circulations et postes de travail
                            </Typography>
                            <img src={balayer} alt="Balayer" />
                        </div>
                    )
                }
            ]
        },
        {
            label: 'Préparation des descentes de cloisons',
            status: 'pending',
            isFilled: true,
            content: [
                {
                    title: 'Risque',
                    description: "Blessures liées à l'utilisation de l'outillage"
                },
                {
                    title: 'Prévention',
                    description: <PortObligatoireDesEpis />
                },
                {
                    title: 'Risque',
                    description: 'Exposition par inhalation des poussières (Bois, silice cristalline, produits chimiques)'
                },
                {
                    title: 'Prévention',
                    description: (
                        <div>
                            <Typography intrinsic="span">
                                Ne pas intervenir en zone exposée aux poussières. Porter un masque FFP3 en cas de risque d'inhalation
                            </Typography>
                        </div>
                    )
                },
                {
                    title: 'Risque',
                    description: 'Electrisation / Electrocution'
                },
                {
                    title: 'Prévention',
                    description: (
                        <div>
                            <Typography intrinsic="span">Utilisation de machines conformes aux normes</Typography>
                            <Typography intrinsic="span">
                                Utilisation de prises, prolongateurs, fiches électriques normalisés et en parfait état
                            </Typography>
                        </div>
                    )
                },
                {
                    title: 'Risque',
                    description: 'Chute de plain-pied'
                },
                {
                    title: 'Prévention',
                    description: (
                        <div>
                            <Typography intrinsic="span">Maintenir les lieux de travail propres et rangés</Typography>
                            <Typography intrinsic="span">Stockage des matériaux sans gêner les circulations</Typography>
                            <img src={balayer} alt="Balayer" />
                        </div>
                    )
                },
                {
                    title: 'Risque',
                    description: 'Chute de hauteur'
                },
                {
                    title: 'Prévention',
                    description: (
                        <div>
                            <Typography intrinsic="span">
                                Utiliser une PIRL conforme sur sol stable et dégagé. Accès libres pour acheminer le matériel d'élévation.
                            </Typography>
                            <img src={pirStabilise} alt="PIR Stabilisée" />
                        </div>
                    )
                },
                {
                    title: 'Risque',
                    description: "Chute d'objets (contreplaqué, par trémies, …)"
                },
                {
                    title: 'Prévention',
                    description: (
                        <div>
                            <Typography intrinsic="span">
                                Nécessité de faire décoffrer entièrement les plafonds des zones de travail avant l'intervention des
                                électriciens
                            </Typography>
                            <Typography intrinsic="span">
                                Nécessité de faire obturer ou baliser les trémies avant l'intervention des électriciens
                            </Typography>
                            <Typography intrinsic="span">
                                Faire maintenir en place en permanence les protections collectives provisoires contre les chutes de hauteur,
                                protections sur trémies
                            </Typography>
                        </div>
                    )
                },
                {
                    title: 'Risque',
                    description: 'Bruit'
                },
                {
                    title: 'Prévention',
                    description: (
                        <div>
                            <Typography intrinsic="span">Port des EPI contre le bruit</Typography>
                            <Typography intrinsic="span">Planifier les tâches pour éviter la coactivité</Typography>
                        </div>
                    )
                },
                {
                    title: 'Risque',
                    description: "Risque lié à l'utilisation du matériel et la manutention des matériaux"
                },
                {
                    title: 'Prévention',
                    description: (
                        <div>
                            <Typography intrinsic="span">
                                Stockage des matériaux sans gêner les circulations et postes de travail
                            </Typography>
                            <img src={balayer} alt="Balayer" />
                        </div>
                    )
                }
            ]
        },
        {
            label: 'Descentes de cloisons',
            status: 'pending',
            isFilled: true,
            content: [
                {
                    title: 'Risque',
                    description: "Blessures liées à l'utilisation de l'outillage"
                },
                {
                    title: 'Prévention',
                    description: <PortObligatoireDesEpis />
                },
                {
                    title: 'Risque',
                    description: 'Exposition par inhalation des gaz et vapeurs'
                },
                {
                    title: 'Prévention',
                    description: (
                        <div>
                            <Typography intrinsic="span">
                                Utilisation de masque de protection respiratoire adapté lorsque le salarié utilise la taupinette
                            </Typography>
                        </div>
                    )
                },
                {
                    title: 'Risque',
                    description: 'Chutes de plain-pied'
                },
                {
                    title: 'Prévention',
                    description: (
                        <div>
                            <Typography intrinsic="span">Maintenir les lieux de travail propres et rangés</Typography>
                            <Typography intrinsic="span">Stockage des matériaux sans gêner les circulations</Typography>
                            <img src={obstaclesSupprimes} alt="Obstacles Supprimés" />
                        </div>
                    )
                },
                {
                    title: 'Risque',
                    description: 'Electrisation / Electrocution'
                },
                {
                    title: 'Prévention',
                    description: (
                        <div>
                            <Typography intrinsic="span">Utilisation de machines conformes aux normes</Typography>
                            <Typography intrinsic="span">
                                Utilisation de prises, prolongateurs, fiches électriques normalisés et en parfait état
                            </Typography>
                        </div>
                    )
                },
                {
                    title: 'Risque',
                    description: 'Chutes de hauteur'
                },
                {
                    title: 'Prévention',
                    description: (
                        <div>
                            <Typography intrinsic="span">Utilisation d'équipements réglementaires adaptés (PIRL)</Typography>
                        </div>
                    )
                }
            ]
        },
        {
            label: 'Réalisation des colonnes montantes',
            status: 'pending',
            isFilled: true,
            content: [
                {
                    title: 'Risque',
                    description: "Blessures liées à l'utilisation de l'outillage"
                },
                {
                    title: 'Prévention',
                    description: <PortObligatoireDesEpis />
                },
                {
                    title: 'Risque',
                    description: 'Electrisation / Electrocution'
                },
                {
                    title: 'Prévention',
                    description: (
                        <div>
                            <Typography intrinsic="span">Utilisation de machines conformes aux normes</Typography>
                            <Typography intrinsic="span">
                                Utilisation de prises, prolongateurs, fiches électriques normalisés et en parfait état
                            </Typography>
                            <img src={brancheAppareil} alt="Branche Appareil" />
                        </div>
                    )
                },
                {
                    title: 'Risque',
                    description: 'Chute de hauteur'
                },
                {
                    title: 'Prévention',
                    description: (
                        <div>
                            <Typography intrinsic="span">Utilisation d'équipements réglementaires adaptés (PIRL)</Typography>
                            <img src={pirStabilise} alt="PIR Stabilisée" />
                            <Typography intrinsic="span">
                                Faire maintenir en place en permanence les protections collectives provisoires contre les chutes de hauteur,
                                protections sur trémies.
                            </Typography>
                        </div>
                    )
                }
            ]
        },
        {
            label: "Pose de l'appareillage",
            status: 'pending',
            isFilled: true,
            content: [
                {
                    title: 'Risque',
                    description: "Blessures liées à l'utilisation de l'outillage"
                },
                {
                    title: 'Prévention',
                    description: <PortObligatoireDesEpis />
                },
                {
                    title: 'Risque',
                    description: 'Chutes de plain-pied'
                },
                {
                    title: 'Prévention',
                    description: (
                        <div>
                            <Typography intrinsic="span">Maintenir les lieux de travail propres et rangés</Typography>
                            <Typography intrinsic="span">Stockage des matériaux sans gêner les circulations</Typography>
                        </div>
                    )
                },
                {
                    title: 'Risque',
                    description: 'Chutes de hauteur'
                },
                {
                    title: 'Prévention',
                    description: (
                        <div>
                            <Typography intrinsic="span">
                                En intérieur, escabeau autorisé si espace restreint ou tâche ponctuelle à faible risque. En extérieur,
                                utiliser PIRL ou échafaudage avec protections collectives (et collaborateurs formés). Sols et accès doivent
                                être stables et dégagés pour l'usage et l'acheminement du matériel d'élévation.
                            </Typography>
                        </div>
                    )
                }
            ]
        },
        {
            label: 'Pose des convecteurs/sèches-serviettes',
            status: 'pending',
            isFilled: true,
            content: [
                {
                    title: 'Risque',
                    description: "Blessures liées à l'utilisation de l'outillage"
                },
                {
                    title: 'Prévention',
                    description: <PortObligatoireDesEpis />
                },
                {
                    title: 'Risque',
                    description: 'Chutes de plain-pied'
                },
                {
                    title: 'Prévention',
                    description: (
                        <div>
                            <Typography intrinsic="span">Maintenir les lieux de travail propres et rangés</Typography>
                            <Typography intrinsic="span">Stockage des matériaux sans gêner les circulations </Typography>
                        </div>
                    )
                }
            ]
        },
        {
            label: "Pose d'antennes et/ou paraboles",
            status: 'pending',
            isFilled: true,
            content: [
                {
                    title: 'Risque',
                    description: 'Chutes de hauteur'
                },
                {
                    title: 'Prévention',
                    description: (
                        <div>
                            <Typography intrinsic="span">
                                1 - Prévoir un maximum d\'opérations au sol pour diminuer la charge de travail réalisé en hauteur
                            </Typography>

                            <Typography intrinsic="span">
                                2 - Prévoir l'approvisionnement du matériel sur toiture à l'aide de la grue
                            </Typography>

                            <img src={pemp} alt="PEMP" />

                            <Typography intrinsic="span">
                                3 - Intervenir prioritairement lorsque les protections collectives du Gros Œuvre sont en place
                            </Typography>

                            <Typography intrinsic="span">
                                4 - En cas d'impossibilité, intervenir en utilisant obligatoirement les EPI contre les chutes de hauteur
                            </Typography>

                            <Typography intrinsic="span">5 - Formation obligatoire des utilisateurs de harnais</Typography>

                            <Typography intrinsic="span">6 - Vérification générale périodique des harnais</Typography>

                            <Typography intrinsic="span">
                                7 - Utilisation systématique de nacelle pour villas ne disposant pas de trappes d'accès en toiture
                            </Typography>

                            <Typography intrinsic="span">8 - Mise en œuvre de la nacelle par collaborateur qualifié</Typography>

                            <img src={circuler} alt="Circuler" />

                            <Typography intrinsic="span">
                                Nécessité de faire maintenir les protections collectives de toiture pour permettre l'intervention de
                                l'électricien en sécurité sur toiture
                            </Typography>
                            <Typography intrinsic="span">
                                Lors de l'utilisation de nacelle, nécessiter de faire dégager les accès jusqu'au pied de bâtiment et faire
                                stabiliser les sols
                            </Typography>
                            <Typography intrinsic="span">
                                Lors des interventions avec harnais, nécessité de mise en place de points d'ancrage réglementaires,
                                obligatoirement accessibles en sécurité avant toutes sorties en toiture
                            </Typography>
                        </div>
                    )
                },
                {
                    title: 'Risque',
                    description: "Blessures liées à l'utilisation de l'outillage"
                },
                {
                    title: 'Prévention',
                    description: <PortObligatoireDesEpis />
                }
            ]
        },
        {
            label: 'Pose de panneaux photovoltaïques',
            status: 'pending',
            isFilled: true,
            content: [
                {
                    title: 'Risque',
                    description: 'Chutes de hauteur'
                },
                {
                    title: 'Prévention',
                    description: (
                        <div>
                            <Typography intrinsic="span">
                                1 - Prévoir un maximum d\'opérations au sol pour diminuer la charge de travail réalisé en hauteur
                            </Typography>

                            <Typography intrinsic="span">
                                2 - Prévoir l'approvisionnement du matériel sur toiture à l'aide de la grue
                            </Typography>

                            <img src={pemp} alt="PEMP" />

                            <Typography intrinsic="span">
                                3 - Intervenir prioritairement lorsque les protections collectives du Gros Œuvre sont en place
                            </Typography>

                            <Typography intrinsic="span">
                                4 - En cas d'impossibilité, intervenir en utilisant obligatoirement les EPI contre les chutes de hauteur
                            </Typography>

                            <Typography intrinsic="span">5 - Formation obligatoire des utilisateurs de harnais</Typography>

                            <Typography intrinsic="span">6 - Vérification générale périodique des harnais</Typography>

                            <Typography intrinsic="span">
                                7 - Utilisation systématique de nacelle pour villas ne disposant pas de trappes d'accès en toiture
                            </Typography>

                            <Typography intrinsic="span">8 - Mise en œuvre de la nacelle par collaborateur qualifié</Typography>

                            <img src={circuler} alt="Circuler" />

                            <Typography intrinsic="span">
                                Nécessité de faire maintenir les protections collectives de toiture pour permettre l'intervention de
                                l'électricien en sécurité sur toiture
                            </Typography>
                            <Typography intrinsic="span">
                                Lors de l'utilisation de nacelle, nécessiter de faire dégager les accès jusqu'au pied de bâtiment et faire
                                stabiliser les sols
                            </Typography>
                            <Typography intrinsic="span">
                                Lors des interventions avec harnais, nécessité de mise en place de points d'ancrage réglementaires,
                                obligatoirement accessibles en sécurité avant toutes sorties en toiture
                            </Typography>
                        </div>
                    )
                },
                {
                    title: 'Risque',
                    description: "Blessures liées à l'utilisation de l'outillage"
                },
                {
                    title: 'Prévention',
                    description: <PortObligatoireDesEpis />
                },
                {
                    title: 'Risque',
                    description: 'Risques électriques'
                },
                {
                    title: 'Prévention',
                    description: (
                        <div>
                            <Typography intrinsic="span">Formation obligatoire : Habilitation BP</Typography>
                            <Typography intrinsic="span">Placer une paroi occultante sur les panneaux</Typography>
                        </div>
                    )
                }
            ]
        },
        {
            label: 'Alimentation des coffrets électriques provisoires',
            status: 'pending',
            isFilled: true,
            content: [
                {
                    title: 'Risque',
                    description: "Blessures liées à l'utilisation de l'outillage"
                },
                {
                    title: 'Prévention',
                    description: <PortObligatoireDesEpis />
                },
                {
                    title: 'Risque',
                    description: 'Chutes de plain-pied'
                },
                {
                    title: 'Prévention',
                    description: (
                        <div>
                            <Typography intrinsic="span">Maintien les lieux de travail propres et rangés</Typography>
                            <Typography intrinsic="span">Pieuvres en attentes rassemblées et attachées</Typography>
                            <img src={pieuvresAttachees} alt="Pieuvres Attachées" />
                        </div>
                    )
                },
                {
                    title: 'Risque',
                    description: 'Électrisation / Electrocution'
                },
                {
                    title: 'Prévention',
                    description: (
                        <div>
                            <Typography intrinsic="span">Utilisation de machines conformes aux normes</Typography>
                            <Typography intrinsic="span">
                                Utilisation de prises, prolongateurs, fiches électriques normalisés et en parfait état
                            </Typography>
                            <img src={electrocution} alt="Electrocution" />
                        </div>
                    )
                },
                {
                    title: 'Risque',
                    description: 'Chutes de hauteur'
                },
                {
                    title: 'Prévention',
                    description: (
                        <div>
                            <Typography intrinsic="span">Utilisation d'équipements réglementaires adaptés (PIRL)</Typography>
                        </div>
                    )
                }
            ]
        },
        {
            label: 'Pose de goulotte',
            status: 'pending',
            isFilled: true,
            content: [
                {
                    title: 'Risque',
                    description: "Blessures liées à l'utilisation de l'outillage"
                },
                {
                    title: 'Prévention',
                    description: <PortObligatoireDesEpis />
                },
                {
                    title: 'Risque',
                    description: 'Chutes de plain-pied'
                },
                {
                    title: 'Prévention',
                    description: (
                        <div>
                            <Typography intrinsic="span">Maintien les lieux de travail propres et rangés</Typography>
                            <Typography intrinsic="span">Pieuvres en attentes rassemblées et attachées</Typography>
                            <img src={pieuvresAttachees} alt="Pieuvres Attachées" />
                        </div>
                    )
                },
                {
                    title: 'Risque',
                    description: 'Chutes de hauteur'
                },
                {
                    title: 'Prévention',
                    description: (
                        <div>
                            <Typography intrinsic="span">Utilisation de plateformes individuelles réglementaires</Typography>
                        </div>
                    )
                }
            ]
        },
        // {
        //     label: 'Essais',
        //     status: 'pending',
        //     isFilled: true,
        //     content: [
        //         {
        //             title: 'En attente de contenu 9',
        //             description: 'En attente de contenu 10'
        //         },
        //         {
        //             title: 'En attente de contenu 11',
        //             description: (
        //                 <div>
        //                     <Typography intrinsic="span">En attente de contenu 12</Typography>
        //                 </div>
        //             )
        //         }
        //     ]
        // },
        {
            label: 'Autre',
            status: 'pending',
            isFilled: false,
            content: [
                {
                    title: 'Title',
                    description: 'Description de la tâche'
                },
                {
                    title: 'Description',
                    description: '' // Content will be generated dynamically
                }
            ]
        }
    ]);



    useEffect(() => {
        if (!worksiteId) {
            navigate('/sante-securite/home-security');
        }
    }, [worksiteId, navigate]);

    const computedStepperSteps = useMemo((): MinimalStepperProps['steps'] => {
        const initialSteps: MinimalStepperProps['steps'] = [
            {
                label: steps[0].label,
                status: currentStep === 0 ? 'inProgress' : 'completed'
            }
        ];

        const dynamicSteps: MinimalStepperProps['steps'] | undefined = steps[0].checkboxes
            ?.filter((checkbox) => checkbox.isChecked)
            .map(({ label }, index) => ({
                label,
                status: index + 1 === currentStep ? 'inProgress' : index + 1 < currentStep ? 'completed' : 'pending'
            }));

        return [...initialSteps, ...(dynamicSteps ?? [])];
    }, [steps, currentStep]);

    const handleCheckboxChange = (currentStep: number, label: string) => {
        setSteps((prevSteps) => {
            const newSteps = prevSteps.map((step, index) =>
                index === currentStep
                    ? {
                          ...step,
                          checkboxes: step.checkboxes?.map((checkbox) =>
                              checkbox.label === label ? { ...checkbox, isChecked: !checkbox.isChecked } : checkbox
                          )
                      }
                    : step
            );

            return [...newSteps];
        });
    };

    // Gestion du isFilled pour l'étape des checkboxes (étape 0)
    const firstStepCheckboxes = steps[0].checkboxes;
    const firstStepIsFilled = steps[0].isFilled;
    useEffect(() => {
        if (currentStep !== 0) return;

        const hasSomeChecked = firstStepCheckboxes?.some((checkbox) => checkbox.isChecked);
        const isAlreadyFilled = firstStepIsFilled;

        if ((hasSomeChecked && isAlreadyFilled) || (!hasSomeChecked && !isAlreadyFilled)) {
            return;
        }

        if (hasSomeChecked && !isAlreadyFilled) {
            setSteps((prevSteps) => {
                return prevSteps.map((step) => ({
                    ...step,
                    isFilled: true
                }));
            });
        }

        if (!hasSomeChecked && isAlreadyFilled) {
            setSteps((prevSteps) => {
                return prevSteps.map((step) => {
                    if (step.checkboxes) {
                        return {
                            ...step,
                            isFilled: false
                        };
                    }
                    return step;
                });
            });
        }
    }, [firstStepCheckboxes, firstStepIsFilled, currentStep]);

    // Gestion du isFilled pour l'étape "Autre"
    useEffect(() => {
        const autreStepIndex = steps.findIndex((step) => step.label === 'Autre');
        if (autreStepIndex === -1) return;

        const shouldBeFilled = otherWorkStep.trim().length > 0;
        const isCurrentlyFilled = steps[autreStepIndex].isFilled;

        // Évite les mises à jour inutiles
        if (shouldBeFilled === isCurrentlyFilled) return;

        setSteps((prevSteps) => {
            return prevSteps.map((step, index) => {
                if (index === autreStepIndex) {
                    return {
                        ...step,
                        isFilled: shouldBeFilled
                    };
                }
                return step;
            });
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [otherWorkStep]);

    const actualStep = useMemo(() => {
        const label = computedStepperSteps[currentStep].label;
        const tempStep = steps.find((step) => step.label === label);
        return tempStep;
    }, [steps, currentStep, computedStepperSteps]);

    const handlePrev = () => {
        const scrollContainer = document.querySelector('.rendered-page');
        if (scrollContainer) {
            scrollContainer.scrollTop = 0;
        }
        setCurrentStep(currentStep - 1);
    };

    const handleNext = () => {
        const isFinished = currentStep === computedStepperSteps.length - 1;
        if (isFinished) {
            handleAddPassedModule('formation');
            const workSteps = steps[0].checkboxes?.filter((checkbox) => checkbox.isChecked).map(({ label }) => label);

            if (!workSteps || workSteps.length < 0) {
                return;
            }

            setWorkStep(workSteps);
            navigate('/sante-securite/home-security/menu');
            return;
        }

        const scrollContainer = document.querySelector('.rendered-page');
        if (scrollContainer) {
            scrollContainer.scrollTop = 0;
        }
        setCurrentStep(currentStep + 1);
    };

    const canGoBack = currentStep > 0;

    const currentStepContent = useMemo(() => {
        const label = computedStepperSteps[currentStep].label;
        const tempStep = steps.find((step) => step.label === label);

        
        // Generate dynamic content for "Autre" step
        if (label === 'Autre' && tempStep?.content) {

            return tempStep.content.map((item) => {
                if (item.title === 'Description') {
                    return {
                        ...item,
                        description: (
                            <div>
                                <Textarea
                                    name='other'
                                    placeholder="Votre texte ici"
                                    value={otherWorkStep}
                                    onValueChange={(e: string) => setOtherWorkStep(e)}
                                    rows={15}
                                />
                            </div>
                        )
                    };
                } 
                return item;
            });
        }

        return tempStep?.content;
    }, [steps, currentStep, computedStepperSteps, otherWorkStep, setOtherWorkStep]);

    return {
        currentStep,
        computedStepperSteps,
        steps,
        handleCheckboxChange,
        handlePrev,
        handleNext,
        canGoBack,
        currentStepContent,
        actualStep
    };
};
